import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm$addingEntity$form, _vm$entity, _vm$entity$images;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    attrs: {
      width: "800",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [!_vm.isAnyActionInProgress ? _c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle mt-1",
    on: {
      click: _vm.close
    }
  })], 1) : _vm._e(), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v(_vm._s(_vm.isAdding ? "Create new region" : "Edit region"))])]), _c("div", {
    staticClass: "content-centered large text-left"
  }, [_vm.isAdding ? [_c(VForm, {
    model: {
      value: _vm.addingEntity.form.isValid,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "isValid", $$v);
      },
      expression: "addingEntity.form.isValid"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.gettingCountries.results,
      "item-text": "printable_name",
      "item-value": "id_country",
      label: _vm.gettingCountries.isPending ? "Loading list of countries" : "Country",
      rules: [_vm.formRules.mustSelectValue],
      "hide-details": "auto",
      disabled: _vm.gettingCountries.isPending,
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.addingEntity.form.countryId,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "countryId", $$v);
      },
      expression: "addingEntity.form.countryId"
    }
  }), _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.productTypes,
      "item-text": "text",
      "item-value": "id",
      label: "Product type",
      "hide-details": "auto",
      rules: [_vm.formRules.mustSelectValue]
    },
    model: {
      value: _vm.addingEntity.form.productType,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "productType", $$v);
      },
      expression: "addingEntity.form.productType"
    }
  }), _c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Name",
      "hide-details": "auto",
      rules: [_vm.formRules.mustNotBeEmpty]
    },
    model: {
      value: _vm.addingEntity.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "name", $$v);
      },
      expression: "addingEntity.form.name"
    }
  }), _c(VTextarea, {
    staticClass: "required",
    attrs: {
      label: "Description",
      "hide-details": "auto",
      rules: [_vm.formRules.mustNotBeEmpty]
    },
    model: {
      value: _vm.addingEntity.form.description,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "description", $$v);
      },
      expression: "addingEntity.form.description"
    }
  }), _c("div", {
    staticClass: "mt-6"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("Sub regions")]), _c("div", {
    staticClass: "mb-2 text-smaller text-italic"
  }, [_vm._v(" Rule for sorting: A smaller number has higher priority ")]), ((_vm$addingEntity$form = _vm.addingEntity.form.regionSubs) === null || _vm$addingEntity$form === void 0 ? void 0 : _vm$addingEntity$form.length) > 0 ? _c("div", _vm._l(_vm.addingEntity.form.regionSubs, function (regionSub, index) {
    var _vm$addingEntity$form2;
    return _c("div", {
      key: "adding-regionSub-" + index
    }, [_c("div", {
      staticClass: "flex items-start gap-3 w-100"
    }, [_c("div", {
      staticClass: "flex-grow"
    }, [_c(VTextField, {
      staticClass: "v-text-field-no-label required",
      attrs: {
        placeholder: "Subregion name",
        "hide-details": "auto",
        rules: [_vm.formRules.mustNotBeEmpty]
      },
      model: {
        value: regionSub.name,
        callback: function callback($$v) {
          _vm.$set(regionSub, "name", $$v);
        },
        expression: "regionSub.name"
      }
    })], 1), _c("div", {
      staticStyle: {
        width: "4rem"
      }
    }, [_c(VTextField, {
      staticClass: "v-text-field-no-label required",
      attrs: {
        type: "number",
        min: 0,
        rules: [_vm.formRules.mustNotBeEmpty],
        "hide-details": "auto"
      },
      on: {
        keypress: _vm.filterIntegerKey
      },
      model: {
        value: regionSub.priority,
        callback: function callback($$v) {
          _vm.$set(regionSub, "priority", $$v);
        },
        expression: "regionSub.priority"
      }
    })], 1), _c("div", {
      staticClass: "ml-2 mt-3"
    }, [_c(VIcon, {
      staticClass: "fa fa-trash icon-link",
      attrs: {
        size: "0.65rem",
        disabled: ((_vm$addingEntity$form2 = _vm.addingEntity.form.regionSubs) === null || _vm$addingEntity$form2 === void 0 ? void 0 : _vm$addingEntity$form2.length) <= 1
      },
      on: {
        click: function click($event) {
          return _vm.addingEntityRemoveRegionSub(index);
        }
      }
    })], 1)])]);
  }), 0) : _vm._e(), _c("div", {
    staticClass: "mt-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.addingEntityStartAddRegionSub();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add sub region ")], 1)], 1)]), _c("div", {
    staticClass: "text-smaller text-italic mt-6"
  }, [_vm._v(" You will be able to add images after the creation ")])], 1), _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress || !_vm.addingEntityIsValid,
      loading: _vm.addingEntity.isPending
    },
    on: {
      click: function click($event) {
        return _vm.confirmSaveAddingEntity();
      }
    }
  }, [_vm._v(" Create region ")])], 1)] : [_vm.gettingEntity.isPending ? _c("div", {
    staticClass: "text-smaller text-italice"
  }, [_vm._v("Loading data")]) : !((_vm$entity = _vm.entity) !== null && _vm$entity !== void 0 && (_vm$entity = _vm$entity.name) !== null && _vm$entity !== void 0 && _vm$entity.length) > 0 ? _c("div", [_vm._v("Error loading data, please try again")]) : _c("div", {
    staticClass: "split-sections"
  }, [_c("section", [_c("div", {
    staticClass: "title"
  }, [_c(VIcon, {
    staticClass: "icon-illustrating fas fa-hashtag"
  }), _vm._v(" Texts "), !_vm.isAnyActionInProgress && !_vm.isAnySubFormInProgress ? _c(VIcon, {
    staticClass: "icon-link fa fa-pen ml-2",
    on: {
      click: function click($event) {
        return _vm.startEditingTexts();
      }
    }
  }) : _vm._e()], 1), !_vm.editingTexts.isConfiguring ? _c("div", [_c("div", [_c("div", {
    staticClass: "text-smaller"
  }, [_vm._v("Name:")]), _c("div", [_vm._v(_vm._s(_vm.entity.name))])]), _c("div", {
    staticClass: "mt-2"
  }, [_c("div", {
    staticClass: "text-smaller"
  }, [_vm._v("Description:")]), _c("div", {
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.entity.description))
    }
  })])]) : _c("div", [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.editingTexts.form.isValid,
      callback: function callback($$v) {
        _vm.$set(_vm.editingTexts.form, "isValid", $$v);
      },
      expression: "editingTexts.form.isValid"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Name",
      "hide-details": "auto",
      rules: [_vm.formRules.mustNotBeEmpty]
    },
    model: {
      value: _vm.editingTexts.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.editingTexts.form, "name", $$v);
      },
      expression: "editingTexts.form.name"
    }
  }), _c(VTextarea, {
    staticClass: "required",
    attrs: {
      label: "Description",
      "hide-details": "auto",
      rules: [_vm.formRules.mustNotBeEmpty]
    },
    model: {
      value: _vm.editingTexts.form.description,
      callback: function callback($$v) {
        _vm.$set(_vm.editingTexts.form, "description", $$v);
      },
      expression: "editingTexts.form.description"
    }
  }), _c("div", {
    staticClass: "mt-3 flex gap-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      disabled: _vm.editingTexts.isPending
    },
    on: {
      click: _vm.cancelEditingTexts
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      loading: _vm.editingTexts.isPending,
      disabled: !_vm.editingTexts.form.isValid
    },
    on: {
      click: _vm.saveEditingTexts
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save ")], 1)], 1)], 1)], 1)]), _c("section", [_c("div", {
    staticClass: "title"
  }, [_c(VIcon, {
    staticClass: "icon-illustrating fas fa-wine-bottle"
  }), _vm._v(" Product types ")], 1), _c("div", [_vm._v(" " + _vm._s(_vm.entity.isWineRegion ? "The region is available for wines" : "The region is available for spirits") + " ")])]), _c("section", [_c("div", {
    staticClass: "title"
  }, [_c(VIcon, {
    staticClass: "icon-illustrating fa fa-image"
  }), _vm._v(" Images ")], 1), ((_vm$entity$images = _vm.entity.images) === null || _vm$entity$images === void 0 ? void 0 : _vm$entity$images.length) > 0 ? _c("div", {
    staticClass: "multiSubs-container"
  }, _vm._l(_vm.entity.images, function (image) {
    var _image$thbAbsoluteUri, _image$absoluteUri, _vm$entity$images2;
    return _c("div", {
      key: "region-image-".concat(image.id),
      staticClass: "flex items-center gap-6"
    }, [((_image$thbAbsoluteUri = image.thbAbsoluteUri) === null || _image$thbAbsoluteUri === void 0 ? void 0 : _image$thbAbsoluteUri.length) > 0 ? _c("img", {
      staticStyle: {
        "max-width": "100%",
        "max-height": "5rem"
      },
      attrs: {
        src: image.thbAbsoluteUri,
        alt: ""
      }
    }) : ((_image$absoluteUri = image.absoluteUri) === null || _image$absoluteUri === void 0 ? void 0 : _image$absoluteUri.length) > 0 ? _c("img", {
      staticStyle: {
        "max-width": "100%",
        "max-height": "5rem"
      },
      attrs: {
        src: image.absoluteUri,
        alt: ""
      }
    }) : _vm._e(), !_vm.isAnySubFormInProgress && !_vm.isAnyActionInProgress ? _c("div", {
      staticClass: "flex gap-2"
    }, [((_vm$entity$images2 = _vm.entity.images) === null || _vm$entity$images2 === void 0 ? void 0 : _vm$entity$images2.length) > 1 ? _c(VIcon, {
      staticClass: "fa fa-sort icon-link",
      attrs: {
        size: "1rem",
        title: "Change sort"
      },
      on: {
        click: function click($event) {
          return _vm.startResortingImage(image);
        }
      }
    }) : _vm._e(), _c(VIcon, {
      staticClass: "fa fa-trash icon-link",
      attrs: {
        size: "1rem",
        title: "Delete"
      },
      on: {
        click: function click($event) {
          return _vm.confirmImageDelete(image);
        }
      }
    })], 1) : _vm._e(), _vm.resortingImage.isConfiguring && _vm.resortingImage.id === image.id ? _c("div", [_c(VForm, {
      staticClass: "dfwa-form flex gap-3 items-end",
      model: {
        value: _vm.resortingImage.form.isValid,
        callback: function callback($$v) {
          _vm.$set(_vm.resortingImage.form, "isValid", $$v);
        },
        expression: "resortingImage.form.isValid"
      }
    }, [_c(VTextField, {
      staticClass: "v-text-field required",
      staticStyle: {
        width: "4rem"
      },
      attrs: {
        label: "New sort",
        type: "number",
        min: 1,
        max: _vm.addingImageMaxSort - 1,
        rules: [_vm.formRules.mustBeGreaterThan0],
        "hide-details": "auto"
      },
      on: {
        keypress: _vm.filterIntegerKey
      },
      model: {
        value: _vm.resortingImage.form.newSort,
        callback: function callback($$v) {
          _vm.$set(_vm.resortingImage.form, "newSort", $$v);
        },
        expression: "resortingImage.form.newSort"
      }
    }), _c("div", {
      staticClass: "flex gap-2 items-center"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: "",
        disabled: _vm.isAnyActionInProgress
      },
      on: {
        click: _vm.cancelResortingImage
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-times mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Cancel ")], 1), _c(VBtn, {
      staticClass: "dfwa-btn --small-2 highlight",
      attrs: {
        rounded: "",
        disabled: !_vm.resortingImage.form.isValid || +_vm.resortingImage.form.newSort == image.sort,
        loading: _vm.resortingImage.isPending
      },
      on: {
        click: _vm.saveResortingImage
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-save mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Save ")], 1)], 1)], 1)], 1) : _vm._e(), _vm.deletingImage.isPending && _vm.deletingImage.id === image.id ? _c("div", {
      staticClass: "text-italic text-smaller"
    }, [_vm._v(" Deleting image ... ")]) : _vm._e()]);
  }), 0) : _c("div", {
    staticClass: "text-smaller text-italic"
  }, [_vm._v("No image")]), _c("div", {
    staticClass: "subform-bordered"
  }, [_vm.addingImage.isConfiguring ? _c(VForm, {
    staticClass: "dfwa-form mt-3",
    model: {
      value: _vm.addingImage.form.isValid,
      callback: function callback($$v) {
        _vm.$set(_vm.addingImage.form, "isValid", $$v);
      },
      expression: "addingImage.form.isValid"
    }
  }, [_c("UploaderV2", {
    key: "uploaderAddingImage",
    ref: "uploaderAddingImage",
    staticClass: "w100p",
    attrs: {
      idInput: "uploaderAddingImage",
      url: _vm.addingImage.url,
      fileTypes: [".png", ".jpg", ".jpeg"],
      additionalHint: "Width:\u22431000px - Height:600px",
      additionalFormData: _vm.addingImageFormWithouValidNormalized,
      multiple: false,
      hideUploadButton: ""
    },
    on: {
      "click:upload": _vm.addingImageUploadSuccess,
      "upload:failed": _vm.addingImageUploadFailed,
      sync: _vm.addingImageSyncFiles
    }
  }), _c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Sort",
      type: "number",
      min: "1",
      max: _vm.addingImageMaxSort,
      "hide-details": "auto",
      rules: [_vm.formRules.mustBeGreaterThan0],
      filter: _vm.filterIntegerKey
    },
    model: {
      value: _vm.addingImage.form.sort,
      callback: function callback($$v) {
        _vm.$set(_vm.addingImage.form, "sort", $$v);
      },
      expression: "addingImage.form.sort"
    }
  }), _c("div", {
    staticClass: "flex gap-2 mt-3"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: _vm.cancelAddingImage
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: !_vm.addingImageCanBeSubmitted || _vm.isAnyActionInProgress,
      loading: _vm.addingImage.isPending
    },
    on: {
      click: _vm.saveAddingImage
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-upload mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Upload ")], 1)], 1)], 1) : _vm._e(), !_vm.isAnyActionInProgress && !_vm.isAnySubFormInProgress ? _c("div", {
    staticClass: "mt-3 mb-1"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.startAddingImage();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add an image ")], 1)], 1) : _vm._e()], 1)]), _c("section", [_c("div", {
    staticClass: "title"
  }, [_c(VIcon, {
    staticClass: "icon-illustrating fas fa-sitemap"
  }), _vm._v(" Subregions ")], 1), _c("div", {
    staticClass: "text-smaller text-italic"
  }, [_vm._v(" Rule for sorting: A smaller number has higher priority ")]), _c("div", {
    staticClass: "multiSubs-container"
  }, _vm._l(_vm.entity.regionSubs, function (regionSub) {
    var _regionSub$image, _regionSub$image$thbA;
    return _c("div", {
      key: "enitity-regionSub-" + regionSub.id
    }, [_vm.editingRegionSub.isConfiguring && _vm.editingRegionSub.id === regionSub.id ? [_c("div", {
      staticClass: "subform-bordered"
    }, [_c(VForm, {
      staticClass: "dfwa-form mt-2",
      model: {
        value: _vm.editingRegionSub.form.isValid,
        callback: function callback($$v) {
          _vm.$set(_vm.editingRegionSub.form, "isValid", $$v);
        },
        expression: "editingRegionSub.form.isValid"
      }
    }, [_c("div", {
      staticClass: "flex items-start gap-3 w-100"
    }, [_c("div", {
      staticClass: "flex-grow"
    }, [_c(VTextField, {
      staticClass: "v-text-field-no-label required",
      attrs: {
        placeholder: "New subregion name",
        "hide-details": "auto",
        rules: [_vm.formRules.mustNotBeEmpty]
      },
      model: {
        value: _vm.editingRegionSub.form.name,
        callback: function callback($$v) {
          _vm.$set(_vm.editingRegionSub.form, "name", $$v);
        },
        expression: "editingRegionSub.form.name"
      }
    })], 1), _c("div", {
      staticStyle: {
        width: "4rem"
      }
    }, [_c(VTextField, {
      staticClass: "v-text-field-no-label required",
      attrs: {
        type: "number",
        min: 0,
        rules: [_vm.formRules.mustNotBeEmpty],
        "hide-details": "auto"
      },
      on: {
        keypress: _vm.filterIntegerKey
      },
      model: {
        value: _vm.editingRegionSub.form.priority,
        callback: function callback($$v) {
          _vm.$set(_vm.editingRegionSub.form, "priority", $$v);
        },
        expression: "editingRegionSub.form.priority"
      }
    })], 1)]), _c("div", {
      staticClass: "flex gap-2 mt-3 mb-2"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: "",
        disabled: _vm.editingRegionSub.isPending
      },
      on: {
        click: _vm.cancelEditingRegionSub
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-times mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Cancel ")], 1), _c(VBtn, {
      staticClass: "dfwa-btn --small-2 highlight",
      attrs: {
        rounded: "",
        disabled: !_vm.editingRegionSub.form.isValid || _vm.isAnyActionInProgress,
        loading: _vm.editingRegionSub.isPending
      },
      on: {
        click: _vm.saveEditingRegionSub
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-save mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Update subregion ")], 1)], 1)]), !_vm.isAnyActionInProgress && !_vm.isAnySubFormInProgress ? _c("div", {
      staticClass: "mt-3 mb-1"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2",
      attrs: {
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.startAddingRegionSub();
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-plus mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Add a subregion ")], 1)], 1) : _vm._e()], 1)] : [_c("div", {
      staticClass: "sub-vertLineSeparated"
    }, [_c("div", [_vm._v(_vm._s(regionSub.name))]), _c("div", {
      staticClass: "text-smaller"
    }, [_c("span", {
      staticClass: "text-smaller"
    }, [_vm._v("Priority :")]), _vm._v(" " + _vm._s(regionSub.priority) + " ")]), !_vm.isAnyActionInProgress && !_vm.isAnySubFormInProgress ? _c("div", {
      staticClass: "sub-vertLineSeparated-buttonsContainer"
    }, [_c(VIcon, {
      staticClass: "icon-link fa fa-pen",
      attrs: {
        size: "0.85rem"
      },
      on: {
        click: function click($event) {
          return _vm.startEditingRegionSub(regionSub);
        }
      }
    })], 1) : _vm._e()]), ((_regionSub$image = regionSub.image) === null || _regionSub$image === void 0 ? void 0 : _regionSub$image.id) > 0 ? _c("div", {
      staticClass: "sub-secondaryGroup"
    }, [_c("div", {
      staticClass: "flex items-center gap-6 mt-1"
    }, [_c("img", {
      staticStyle: {
        "max-width": "100%",
        "max-height": "5rem"
      },
      attrs: {
        src: (_regionSub$image$thbA = regionSub.image.thbAbsoluteUri) !== null && _regionSub$image$thbA !== void 0 ? _regionSub$image$thbA : regionSub.image.asboluteUri,
        alt: ""
      }
    }), !_vm.isAnyActionInProgress ? _c("div", {
      staticClass: "flex gap-2"
    }, [_c(VIcon, {
      staticClass: "fa fa-trash icon-link",
      attrs: {
        size: "1rem",
        title: "Delete image"
      },
      on: {
        click: function click($event) {
          return _vm.confirmRegionSubImageDelete(regionSub.image);
        }
      }
    })], 1) : _vm._e(), _vm.deletingRegionSubImage.isPending && _vm.deletingRegionSubImage.id === regionSub.image.id ? _c("div", {
      staticClass: "text-italic text-smaller"
    }, [_vm._v(" Deleting image ... ")]) : _vm._e()])]) : !_vm.isAnyActionInProgress & !_vm.isAnySubFormInProgress ? _c("div", [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.startAddingRegionSubImage(regionSub);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-plus mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Add an image ")], 1)], 1) : _vm._e()]], 2);
  }), 0), _c("div", {
    staticClass: "subform-bordered"
  }, [_vm.addingRegionSub.isConfiguring ? _c(VForm, {
    staticClass: "dfwa-form mt-2",
    model: {
      value: _vm.addingRegionSub.form.isValid,
      callback: function callback($$v) {
        _vm.$set(_vm.addingRegionSub.form, "isValid", $$v);
      },
      expression: "addingRegionSub.form.isValid"
    }
  }, [_c("div", {
    staticClass: "flex items-start gap-3 w-100"
  }, [_c("div", {
    staticClass: "flex-grow"
  }, [_c(VTextField, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      placeholder: "New subregion name",
      "hide-details": "auto",
      rules: [_vm.formRules.mustNotBeEmpty]
    },
    model: {
      value: _vm.addingRegionSub.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.addingRegionSub.form, "name", $$v);
      },
      expression: "addingRegionSub.form.name"
    }
  })], 1), _c("div", {
    staticStyle: {
      width: "4rem"
    }
  }, [_c(VTextField, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      type: "number",
      min: 0,
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    on: {
      keypress: _vm.filterIntegerKey
    },
    model: {
      value: _vm.addingRegionSub.form.priority,
      callback: function callback($$v) {
        _vm.$set(_vm.addingRegionSub.form, "priority", $$v);
      },
      expression: "addingRegionSub.form.priority"
    }
  })], 1)]), _c("div", {
    staticClass: "text-smaller text-italic mt-3"
  }, [_vm._v(" You will be able to add an image after the creation ")]), _c("div", {
    staticClass: "flex gap-2 mt-3 mb-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      disabled: _vm.addingRegionSub.isPending
    },
    on: {
      click: _vm.cancelAddingRegionSub
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: !_vm.addingRegionSub.form.isValid || _vm.isAnyActionInProgress,
      loading: _vm.addingRegionSub.isPending
    },
    on: {
      click: _vm.confirmSaveAddingRegionSub
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Create new subregion ")], 1)], 1)]) : _vm._e(), !_vm.isAnyActionInProgress && !_vm.isAnySubFormInProgress ? _c("div", {
    staticClass: "mt-3 mb-1"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.startAddingRegionSub();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add a subregion ")], 1)], 1) : _vm._e()], 1)])])]], 2)], 1)], 1), _vm.addingRegionSubImage.isConfiguring ? _c("RegionSubImageUploadModal", {
    ref: "addingRegionSubImageModal",
    attrs: {
      regionSub: _vm.addingRegionSubImage.regionSub,
      loggedUserData: _vm.loggedUserData
    },
    on: {
      uploaded: _vm.addingRegionSubImageUploaded,
      closed: _vm.addingRegionSubImageModalClosed
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };